__turbopack_context__.v({
  "projects-list": "ProjectsList-module-sass-module__MVogfG__projects-list",
});
